import { type ChartDataset } from "chart.js";

import { type AnnotationDataset } from "./hooks/use-build-annotation-dataset";

export type { AnnotationDataset };
export { annotationPlugin } from "./annotation-chart-plugin/annotation-plugin";
export { useBuildAnnotationDataset } from "./hooks/use-build-annotation-dataset";

export { AnnotationsFlyout } from "./annotations-flyout";
export { AnnotationsFlyoutButton } from "./annotations-flyout-button";

export interface Annotation {
  id: string;
  clientId: string;
  userId: string;
  description: string;
  annotatedDate: string;
  endDate?: string;
  campaignType?: string;
  updatedAt: string;
  user?: {
    first_name: string;
    last_name: string;
  };
  isUsedForTraining?: boolean;
}

export type NewAnnotation = Omit<Annotation, "id" | "updatedAt" | "user">;

export const isAnnotationDataset = <
  T extends { label: ChartDataset["label"] },
>({
  label,
}: T) => label === "annotation-plugin";
